export const SYNTH_TRACK_COLORS = Object.freeze([
  Object.freeze({ solid: '#22d3ee', soft: 'rgba(34, 211, 238, 0.32)', text: '#a5f3fc' }),
  Object.freeze({ solid: '#a78bfa', soft: 'rgba(167, 139, 250, 0.32)', text: '#ddd6fe' }),
  Object.freeze({ solid: '#34d399', soft: 'rgba(52, 211, 153, 0.32)', text: '#a7f3d0' }),
  Object.freeze({ solid: '#fb923c', soft: 'rgba(251, 146, 60, 0.32)', text: '#fed7aa' }),
  Object.freeze({ solid: '#f472b6', soft: 'rgba(244, 114, 182, 0.32)', text: '#fbcfe8' }),
  Object.freeze({ solid: '#facc15', soft: 'rgba(250, 204, 21, 0.32)', text: '#fef08a' }),
  Object.freeze({ solid: '#60a5fa', soft: 'rgba(96, 165, 250, 0.32)', text: '#bfdbfe' }),
  Object.freeze({ solid: '#a3e635', soft: 'rgba(163, 230, 53, 0.32)', text: '#d9f99d' }),
])
export const SYNTH_REFERENCE_TRACK_OPACITY = 0.24

export function getSynthTrackColor(trackIndex) {
  return SYNTH_TRACK_COLORS[Math.abs(Number(trackIndex) || 0) % SYNTH_TRACK_COLORS.length]
}

export function getSynthTrackVisualState(trackIndex, activeTrackIndex = null, editable = false) {
  const isActiveTrack = activeTrackIndex == null || trackIndex === activeTrackIndex
  return {
    isActiveTrack,
    isReferenceTrack: !isActiveTrack,
    isEditable: Boolean(editable && isActiveTrack),
    opacity: isActiveTrack ? 1 : SYNTH_REFERENCE_TRACK_OPACITY,
  }
}
